
import {
  computed, defineComponent, ref,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import { useSpacesStore } from '../store/spacesStore';
import SpacesUser from './SpacesUser.vue';
import SpacesUserTransition from './SpacesUserTransition.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';

export default defineComponent({
  props: {
    skeleton: { type: Boolean, default: false },
  },
  components: {
    SpacesUser,
    SpacesUserTransition,
    AppItemWrapper,
    AppSkeletonContact,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const showAll = ref(false);

    const my = computed(() => spacesStore.filteredMyContacts);

    return {
      spacesStore,
      my,
      NETWORK_CONTACT_TYPES,
      showAll,
    };
  },
});
